import { useState, useMemo } from "react";

import { getIcon } from "../../Buttons/IconButton";
import { Maps } from "../MapTileLayer";
import Container from "../MapPortal";
import IconButton from "../../Buttons/IconButton";

import {
  LayerControlContainer,
  LayerControlFooter,
  LayerControlFooterText,
  LayerControlHeader,
  LayerControlMenu,
  LayerControlTile,
  LayerControlTitle,
  LayerIconContainer,
} from "./Styles";
import { MapTile, MapTilesContainer } from "./MapTilesContainer";
import osm from "../../../assets/tile-osm.png";
import topo from "../../../assets/tile-topo.png";
import winter from "../../../assets/tile-winter.png";
import zomer from "../../../assets/tile-zomer.png";

interface MapLayerControlProps {
  activeLayer: Maps;
  onChangeActiveLayer: (layer: Maps) => void;
}

export default function MapLayerControl(props: MapLayerControlProps) {
  const [layerListOpen, setLayerListOpen] = useState(false);
  const activeTile = useMemo(() => {
    switch (props.activeLayer) {
      case Maps.OSM:
        return osm;
      case Maps.TOPO:
        return topo;
      case Maps.LUFOZOMER:
        return zomer;
      case Maps.LUFOWINTER:
        return winter;
      default:
        return osm;
    }
  }, [props.activeLayer]);
  const availableMaptiles: MapTile[] = [
    { background: osm, layer: Maps.OSM, title: "OpenStreetMap" },
    { background: topo, layer: Maps.TOPO, title: "TOPO" },
    { background: winter, layer: Maps.LUFOWINTER, title: "LUFO Winter 2023" },
    { background: zomer, layer: Maps.LUFOZOMER, title: "LUFO Zomer 2023" },
  ];

  return (
    <Container bottom>
      <LayerControlContainer>
        <LayerControlTile
          background={activeTile}
          onClick={() => setLayerListOpen(!layerListOpen)}
        >
          <LayerControlFooter>
            <LayerIconContainer>
              {getIcon("layer-group", "small", false, "white")}
              <LayerControlFooterText>Lagen</LayerControlFooterText>
            </LayerIconContainer>
          </LayerControlFooter>
        </LayerControlTile>

        {layerListOpen && (
          <LayerControlMenu>
            <LayerControlHeader>
              <LayerControlTitle>Achtergrondlagen</LayerControlTitle>
              <IconButton
                borderColor="white"
                tooltip="Sluit venster"
                onClick={() => setLayerListOpen(!layerListOpen)}
                icon="cross"
              />
            </LayerControlHeader>
            <MapTilesContainer
              tiles={availableMaptiles}
              activeLayer={props.activeLayer}
              onChangeActiveLayer={props.onChangeActiveLayer}
            />
          </LayerControlMenu>
        )}
      </LayerControlContainer>
    </Container>
  );
}
